// frontend/src/services/qcfService.js
//
// Ambil data glyph QCF V2 per-surah (hasil split-qcf-data.js), di-cache
// in-memory per session biar nggak fetch ulang tiap ganti tab.

const qcfCache = new Map(); // surahNumber -> { [ayahNumber]: { text, font_family, page_number } }

export const getQcfSurah = async (surahNumber) => {
  if (qcfCache.has(surahNumber)) {
    return qcfCache.get(surahNumber);
  }
  try {
    const res = await fetch(`/qcf-v2/data/${surahNumber}.json`);
    if (!res.ok) throw new Error(`QCF data not found for surah ${surahNumber}`);
    const data = await res.json();
    qcfCache.set(surahNumber, data);
    return data;
  } catch (error) {
    console.error("Error loading QCF V2 data:", error);
    return null; // caller harus fallback ke teks Unicode biasa kalau null
  }
};

// Ambil 1 ayat spesifik: { text, font_family, page_number } | null
export const getQcfAyah = async (surahNumber, ayahNumber) => {
  const surahData = await getQcfSurah(surahNumber);
  return surahData?.[ayahNumber] || null;
};
